export default {
    directorios: [],
    categoriasNegociosAsoc: [],
    productosNegociosAsoc: [],
    descuentosNegociosAsoc: []
}